var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.528 7.80561C16.7964 8.0741 16.7964 8.5094 16.528 8.77788L10.1113 15.1946C9.84281 15.463 9.40751 15.463 9.13903 15.1946L5.47236 11.5279C5.20387 11.2594 5.20387 10.8241 5.47236 10.5556C5.74085 10.2871 6.17615 10.2871 6.44463 10.5556L9.62516 13.7361L15.5557 7.80561C15.8242 7.53713 16.2595 7.53713 16.528 7.80561Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9fb29cd8b5e3eb5c147358029ead4b70.svg";
export { ForwardRef as ReactComponent };